import { render, staticRenderFns } from "./TradeDetail.vue?vue&type=template&id=dfb5a210&scoped=true&"
import script from "./TradeDetail.vue?vue&type=script&lang=js&"
export * from "./TradeDetail.vue?vue&type=script&lang=js&"
import style0 from "./TradeDetail.vue?vue&type=style&index=0&id=dfb5a210&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfb5a210",
  null
  
)

export default component.exports